import { Circle } from "react-feather";
import { BiBookmark } from "react-icons/bi";
import { FiExternalLink } from "react-icons/fi";

export default [
	{
		header: "Алсын зайн сургалт",
	},
	{
        id: 'calendar',
        title: 'Сургалтын хуанли',
        icon: <i className="far fa-calendar-alt"></i>,
        navLink: "/calendar",
    },
	{
		id: "lesson",
		title: "Хичээл",
		icon: <BiBookmark />,
		navLink: "/lesson",
		children: [
			{
				id: "teach-lesson",
				title: "Заах хичээл",
				icon: <Circle size={8} />,
				navLink: "lesson/teach-lesson/",
			},
			{
				id: "schedule-information",
				title: "Хичээлийн хуваарь",
				icon: <Circle size={8} />,
				navLink: "lesson/lesson-schedule/",
			},
			{
				id: "lesson-score",
				title: "Хичээлийн дүн оруулах",
				icon: <Circle size={8} />,
				navLink: "lesson/lesson-score",
			},
			// {
			// 	id: "schedule-exam",
			// 	title: "Шалгалтын хуваарь",
			// 	icon: <Circle size={8} />,
			// 	navLink: "student/payment-information",
			// },
			// {
			// 	id: "dadlaga",
			// 	title: "Өмнөх улирлын дадлага",
			// 	icon: <Circle size={8} />,
			// 	navLink: "student/scoring-system",
			// },
			// {
			// 	id: "tootsoh-huudas",
			// 	title: "Сургалтын ажлын тооцох хуудас",
			// 	icon: <Circle size={8} />,
			// 	navLink: "student/scoring-system",
			// },
			// {
			// 	id: "kredit",
			// 	title: "Сургалтын кредитийн тооцоо",
			// 	icon: <Circle size={8} />,
			// 	navLink: "student/scoring-system",
			// },
		],
	},
	{
		id: "elearning",
		title: "Цахим сургалт",
        icon: <FiExternalLink />,
		navLink: "/lesson/tsahimsurgalt",
	},
	{
        id: 'test',
        title: 'Шалгалт',
        icon: <i className="fas fa-user-check"></i>,
        navLink: "/challenge",
		children: [
			{
				id: "e-challenge",
				title: "Асуултын сан",
				icon: <Circle size={8} />,
				navLink: "challenge/equestion/",
			},
			{
				id: "testchallenge",
				title: "Онлайн шалгалт",
				icon: <Circle size={8} />,
				navLink: "challenge/test/",
			},
			// {
			// 	id: "challenge",
			// 	title: "Онлайн шалгалт",
			// 	icon: <Circle size={8} />,
			// 	navLink: "challenge/challenge/",
			// },
			{
				id: "challenge-timetable",
				title: "Шалгалтын хуваарь",
				icon: <Circle size={8} />,
				navLink: "challenge/exam_schedule/",
			},
		]
    },
];
